<template>
    <div class="main">
        <div class="main_0">
            <!-- <div class="main_0_left">
                <van-icon :name="" size="0.24rem" />
            </div> -->
            <div class="main_0_right">
                <van-notice-bar
                :scrollable="true"
                  :left-icon="require('../../assets/draft/notice.png')"
                  background="#E7F1FC"
                  color='#626B7F'
                  text="长沙****公司 成交88.21万,广州****公司 成交200.32万,武汉****公司 成交50.88万,上海****公司 成交28.98万"
                />
            </div>
        </div>
        <div class="main_1">
            <banner></banner>
        </div>
        <div class="main_2">
            <ul>
                <li @click="gourl(item)" v-for="(item,index) in nav">
                    <van-icon :name="item.img" size="0.88rem" />
                    <b>{{item.name}}</b>
                </li>
            </ul>
        </div>
        <div class="main_3">
            <div class="main_title">
                <h2>传票询价</h2>
                <router-link to="example">查看示例</router-link>
            </div>
            <div class="main_body">
                <div class="main_body_top">
                    <h2>今日最低利率</h2>
                    <p>商票<b>6.000%</b>银票<b>2.000%</b></p>
                </div>
                <div class="main_body_center">
                    <van-button 
                    type="primary" 
                    size="large"
                    :icon="require('../../assets/draft/upload.png')"
                    color="#DC281E" 
                    @click="gourl({url:'addDraft',type:'router'})"
                    >传票立即询价</van-button>
                </div>
            </div>
        </div>
        <div class="main_3 main_3_1">
            <div class="main_title">
                <h2>票据购买</h2>
                <!-- <router-link to="example">查看示例</router-link> -->
            </div>
            <div class="main_body">
                <div class="main_body_top">
                    <h2>购买票据支付货款</h2>
                    <p>节约<b>0.8%-5%</b>资金成本</p>
                </div>
                <div class="main_body_center">
                    <van-button 
                    type="primary" 
                    size="large"
                    :icon="require('../../assets/draft/upload.png')"
                    color="#1B83EB" 
                    @click="gourl({url:'release',type:'router'})"
                    >发布购票需求</van-button>
                </div>
            </div>
        </div>
        <div class="main_4">
            <van-image :src="require('../../assets/draft/main_4.png')" width="100%" />
        </div>
        <div class="main_5">
            <div class="main_title">
                <h2>操作指南</h2>
            </div>
            <div class="main_body">
                <van-image :src="require('../../assets/draft/main_5.png')" width="100%" />
            </div>
        </div>
        <div class="main_6">
            <van-tabs 
            line-width="0.64rem"
            line-height="0.08rem" 
            :border="false"
            :ellipsis="false"
            >
                <van-tab title="中小微企业">
                    <van-tabs 
                    line-width="0"
                    line-height="0" 
                    swipeable
                    :lazy-render="false"
                    :border="false"
                    :ellipsis="false"
                    class="van-tab1"
                    >
                        <van-tab title="票据贴现">
                            <van-image :src="require('../../assets/draft/1.png')" width="100%" />
                        </van-tab>
                        <van-tab title="票据质押">
                            <van-image :src="require('../../assets/draft/2.png')" width="100%" />
                        </van-tab>
                        <van-tab title="应付账款票据解决方案">
                            <van-image :src="require('../../assets/draft/3.png')" width="100%" />
                        </van-tab>
                        <van-tab title="供应链金融解决方案">
                            <van-image :src="require('../../assets/draft/4.png')" width="100%" />
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab title="大型企业">
                    <van-tabs 
                    line-width="0"
                    line-height="0" 
                    swipeable
                    :lazy-render="false"
                    :border="false"
                    :ellipsis="false"
                     class="van-tab1"
                    >
                    <van-tab title="ABS融资">
                        <van-image :src="require('../../assets/draft/5.png')" width="100%" />
                    </van-tab>
                    <van-tab title="标准化票据">
                        <van-image :src="require('../../assets/draft/6.png')" width="100%" />
                    </van-tab>
                    <van-tab title="商票增信及流动性解决方案">
                        <van-image :src="require('../../assets/draft/7.png')" width="100%" />
                    </van-tab>
                </van-tabs>
              </van-tab>
            </van-tabs>
        </div>
        <van-image 
        class="telmain"
        :src="require('../../assets/draft/tel1.png')" 
        width="1.24rem" 
        @click="gourl({url:'19911534004',type:'tel'})"
        />
        <van-popup v-model="$store.state.successPopup" class="upload_success">
            <div class="info_title">
                <van-icon :name="require('../../assets/draft/close.png')" size="0.32rem" @click="$store.dispatch('set_successPopup',false);"/>
            </div>
            <div class="info_body">
                <van-image :src="require('../../assets/draft/success1.png')" width="100%" />
                <p>您的汇票已成功上传</p>
                <p>小基正在为您加速匹配自己方</p>
            </div>
            <div class="info_bottom">
                <van-button 
                type="primary"
                 plain 
                 size="large" 
                 round 
                 :color="$store.state.black" 
                 :to="{path:'addDraft',query:{shopid:this.$route.query.shopid,shopname:this.$route.query.shopname,orgid:this.$route.query.orgid,manageuid:this.$route.query.manageuid,manageuname:this.$route.query.manageuname}}">继续上传</van-button>
                <van-button type="primary" size="large" round color="#DC281E" to="myAdd">查看汇票</van-button>
            </div>
        </van-popup>
        <div class='islogin' v-if="$store.state.loginstatus!='1'">
            <van-image :src="require('../../assets/draft/islogin.png')"  width="6.94rem" height="1rem" @click="gourl({url:'login',type:'router'})"/>
        </div>
        <div class='islogin' v-if="$store.state.loginstatus=='1'&&attestationobj.userstatus!='1'&&attestationobj.userstatus!='2'&&attestationobj.userstatus!='3'">
            <van-image :src="require('../../assets/draft/isattestation.png')"  width="6.94rem" height="1rem" @click="gourl({url:'attestationone',type:'router'})"/>
        </div>
        <!-- <div class="wxguanzhu" v-if="$store.state.userdata&&$store.state.userdata.bindwxmp!='1'&&$store.state.loginstatus=='1'">
            <a href="https://mp.weixin.qq.com/s/o0czXv-KpDGJBuhv9-S2KQ">
                <div class="left">
                    <van-image src="https://img.tgj168.com/static/images/mbp/tgjlyh_code.jpg"  width="0.88rem" height="0.88rem"/>
                </div>
                <div class="right">
                    <p>想要实时获得最新报价推送？</p>
                    <p>关注“铁公基”公众号获取最新报价信息</p>
                </div>
                <van-icon :name="require('../../assets/draft/cdd_delete.png')"  size="0.2rem"/>
            </a>
        </div> -->
        <bottomNav></bottomNav>
    </div>
</template>
<script>
import bottomNav from "@/components/bottomNav";
import banner from "@/components/banner";
import Qs from 'qs';
import { image,Sticky,Tab,Tabs,Icon,field,CellGroup,button,CountDown,Toast,popup,NoticeBar} from 'vant';
export default {
	components: {
        bottomNav,
        banner,
		[image.name]:image,
		[Sticky.name]:Sticky,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
        [field.name]: field,
        [Icon.name]: Icon,
        [CellGroup.name]:CellGroup,
        [button.name]:button,
        [CountDown.name]:CountDown,
        [Toast.name]:Toast,
        [popup.name]:popup,
        [NoticeBar.name]:NoticeBar,
	},
	data(){
		return {
            attestationobj:'',
            headLines:[
                {text:'一条来自远方成交的消息1'},
                {text:'一条来自远方成交的消息2'},
                {text:'一条来自远方成交的消息3'},
                {text:'一条来自远方成交的消息4'},
            ],
            nav: [
            	{url:'capitalIndex',name:'平台资方',type:'router',img:require('../../assets/draft/nav_1.png')},
            	{url:'addDraft',name:'价格试算',type:'router',img:require('../../assets/draft/nav_2.png')},
                {url:'quotetoday',name:'今日报价',type:'router',img:require('../../assets/draft/nav_5.png')},
            	// {url:'19911534004',name:'电话咨询',type:'tel',img:require('../../assets/draft/nav_3.png')},
            	{url:'customerIndex',name:'联系客服',type:'router',img:require('../../assets/draft/nav_4.png')}, 
            ],
		}
	},
	created() {
        this.initData();
	},
    mounted() {
        
    },
	methods: {
        initData(){
            this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=se_user_profile&m=user_byid"), Qs.stringify({
            })).then((res) => {
                if(res.data.status_code == 200){
                    this.attestationobj=res.data.data;
                }
            })
        },
        gourl(e){
            if(e.url=='addDraft'){
                if(this.$store.state.loginstatus==1){
                    this.$router.push({
                        path: e.url,
                        query:{
                            shopid:this.$route.query.shopid,
                            shopname:this.$route.query.shopname,
                            orgid:this.$route.query.orgid,
                            manageuid:this.$route.query.manageuid,
                            manageuname:this.$route.query.manageuname,
                        }
                    });
                }else{
                    if(!this.$islogin()){
                        this.$router.push({
                            path: 'login',
                            query:{
                                id:this.$route.query.tid,
                                shopid:this.$route.query.shopid,
                                shopname:this.$route.query.shopname,
                                orgid:this.$route.query.orgid,
                                manageuid:this.$route.query.manageuid,
                                manageuname:this.$route.query.manageuname,                           }
                        });
                    }
                }
                // this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=se_user_profile&m=user_byid"), Qs.stringify({
                // })).then((res) => {
                //     if(res.data.status_code == 200){
                //         let obj=res.data.data
                //         if(obj.userstatus!=1&&obj.userstatus!=2&&obj.userstatus!=3){
                //             Dialog.confirm({
                //               title: '温馨提示',
                //               message: '实名认证后方可开通银票商票业务',
                //               width:"6.4rem",
                //               confirmButtonText:'实名认证'
                //             })
                //             .then(() => {
                //                 this.$router.push({
                //                     path: 'attestationone',
                //                 });
                //             })
                //             .catch(() => {
                //             // on cancel
                //             });
                //         }else{
                //             this.$router.push({
                //                 path: e.url,
                //             });
                //         }
                        
                //     }else if(res.data.status_code == 201){
                //         if(!this.$islogin()){
                //             this.$router.push({
                //                 path: 'login',
                //                 query:{
                //                     id:this.$route.query.tid
                //                 }
                //             });
                //         }
                //     }
                // }) 
            }else{
                if(e.type=="router"){
                	this.$router.push({
                		path: e.url,
                        query:{
                            id:this.$route.query.tid,
                            shopid:this.$route.query.shopid,
                            shopname:this.$route.query.shopname,
                            orgid:this.$route.query.orgid,
                            manageuid:this.$route.query.manageuid,
                            manageuname:this.$route.query.manageuname,
                            }
                	});
                }else if(e.type=="tel"){
                	window.location.href="tel:"+e.url;
                }
            }
        },
        
	},
    activated () {
        this.initData();
    },
    watch: {
     //    '$store.state.maincatids' (val,oldVal) {
            
    	// }
    },
};
</script>
<style scoped lang="less">
@import '../../style/css/variable.less';
.main{
    background: #f5f5f5;
    .main_0{
        width: 100%;
        height: 0.64rem;
        line-height: 0.64rem;
        overflow: hidden;
        background: #E7F1FC;
        // .flex-start();
        .main_0_left{
            .flex-start();
            min-width: 0.76rem;
            padding:0 0.12rem 0 0.4rem;
        }
        .main_0_right{
            height: 0.64rem;
            line-height: 0.64rem;
            .van-swipe{
                width: 100%;
                height: 0.64rem ;
                line-height: 0.64rem;
                .van-swipe-item{
                    font-size: 0.28rem;
                    height:0.64rem;
                    line-height: 0.64rem;
                    color:#626B7F;
                    .ellipsis();
                }
            }
        }
    }
    .main_1{
        margin:0.16rem 0 0 0;
        padding: 0 0.28rem;
    }
    .main_2{
        margin:0.4rem 0 0 0;
        padding: 0 0.28rem;
        ul{
        	display: flex;
        	justify-content: space-between;
        	li{
        		flex: 1;
        		display: flex;
        		justify-content: center;
        		flex-flow: column;
        		align-items: center;
        		b{
                    font-weight: normal;
        			margin:0.20rem 0 0 0;
        			color:@black;
        			line-height:0.36rem;
        			font-size: 0.24rem;
        		}
        	}
        }
    }
    
    .main_3{
        margin:0.64rem 0 0 0;
        padding: 0 0.28rem;
        .main_title{
            .flex-between();
            margin:0 0 0.24rem 0;
            h2{
              line-height: 0.5rem;
              font-size: 0.36rem;
              color:@black;
              margin:0 0 0 0.08rem;
            }
            a{
                color:#626B7F;
                line-height: 0.5rem;
                font-size: 0.24rem;
            }
        }
        .main_body{
            overflow: hidden;
            height: 4.2rem;
            background: url(../../assets/draft/upload_bg.png) no-repeat center;
            background-size: 100% 100%;
            .main_body_top{
                margin:0.32rem 0 0 0.32rem;
                .flex-between();
                height: 0.4rem;
                h2{
                  line-height: 0.4rem;
                  font-size: 0.28rem;
                  color:@black;  
                }
                p{
                    .flex-start();
                    color:#ACACAC;
                    font-size: 0.24rem;
                    b{
                        margin:0 0.24rem 0 0.1rem;
                        color:@main;
                        font-size: 0.24rem;
                    }
                }
            }
            .main_body_center{
                .flex-center();
                margin:0.8rem 0 0 0;
                .van-button{
                    width: 2.74rem;
                	.flex-center();
                	height:0.8rem;
                	line-height: 0.8rem;
                	font-size:0.24rem;
                    .van-button__content{
                        .flex-start();
                        .van-icon{
                            margin:0 0.2rem 0 0;
                            .flex-start();
                        }
                    }
                }
            }
        }
    }
    .main_3_1{
        margin-top: 0.5rem;
        .main_body{
            background: url(../../assets/draft/upload_bg1.png) no-repeat center;
            background-size: 100% 100%;
            .main_body_top p b{
                color: #1B83EB;
                margin: 0 0.1rem;
            }
        }
        
    }
    .main_4{
        margin:0.48rem 0 0 0;
        padding: 0 0.28rem;
    }
    .main_5{
        margin:0.48rem 0 0 0;
        padding: 0 0.28rem;
        .main_title{
            .flex-between();
            margin:0 0 0.24rem 0;
            h2{
              line-height: 0.5rem;
              font-size: 0.36rem;
              color:@black;
              margin:0 0 0 0.08rem;
            }
            a{
                color:#626B7F;
                line-height: 0.5rem;
                font-size: 0.24rem;
            }
        }
    }
    .main_6{
        margin:0.48rem 0 0.8rem 0;
        padding: 0 0.28rem;
    }
    .islogin{
        z-index: 999;
        position: fixed;
        left: 0.28rem;
        width: 100%;
        bottom:1.2rem;
    }
    .wxguanzhu{
        z-index: 999;
        position: fixed;
        right: 0;
        width: 100%;
        bottom:1.2rem;
        background: rgba(0, 0, 0, 0.85);
        padding: 0.18rem 0.32rem 0.14rem 0.32rem;
        justify-content: center;
        a{
            display: flex;
            align-items: center;
            .left{
                margin:0 0.16rem 0 0;
            }
            .right{
                p{
                    font-size: 0.24rem;
                     font-weight: bold;
                     line-height: 0.32rem;
                     color: @white; 
                     &:first-child{
                         margin:0 0 0.08rem 0;
                     }
                } 
            }
        }
        
        .van-icon{
             position: absolute;
            padding: 0.16rem 0.32rem 0.32rem 0.32rem;
            top: 0;
            right: 0;
            display: flex;
        }
    }
    .wxguanzhu_wrap{
        height: 1.2rem;
    }
    ::v-deep{
        .van-notice-bar{
            height: 0.64rem;
            padding: 0 0.16rem 0 0.4rem;
            font-size:0.28rem;
            .van-icon{
                font-size: 0.28rem;
            }
        }
        .upload_success{
            width:6.3rem;
            height: 7.48rem;
            border-radius: 0.18rem;
            .info_title{
                .flex-end();
                padding: 0 0.32rem 0 0;
                height: 1rem;
            }
            .info_body{
                padding: 0.6rem 0 0.8rem 0;
                p{
                    text-align: center;
                    font-size: 0.28rem;
                    line-height: 0.38rem;
                    color: @black;
                }
            }
            .info_bottom{
                padding: 0 0.2rem;
                .flex-between();
                .van-button{
                    width: 2.8rem;
                    height:0.8rem;
                    line-height: 0.8rem;
                    font-size:0.28rem;
                }
            }
        }
        .van-tabs__nav{
            background: transparent;
        }
        .van-tabs{
        	line-height: 0.88rem;
        	.van-tabs__line {
        		line-height: 0.88rem;
        		height:0.08rem;
        		width: 0.64rem;
        		background: @main;
        		border-radius:0.34rem;
        	}
        	.van-tabs__wrap{
        		line-height: 0.88rem;
        		height: 0.88rem;
        	}
        	.van-tab{
        		line-height: 0.88rem;
        		height: 0.88rem;
        		font-size:0.28rem;
                font-weight: bold;
        		color:@black;
        		&.van-tab--active{
        			color:@black;
                    font-size:0.28rem;
        		}
        	}
            .van-tabs__content{
                padding:0.4rem 0 0 0;
            }
        }
        
        .van-tab1{
            .van-tabs__wrap{
            	line-height: 0.48rem;
            	height: 0.48rem;
            }
            .van-tab{
            	line-height: 0.44rem;
            	height: 0.48rem;
            	font-size:0.28rem;
                font-weight: bold;
            	color:@grey_7;
            	&.van-tab--active{
            		padding: 0 0.28rem;
            		height: 0.48rem;
            		background: #FFD6D6;
                    color:@main;
            		opacity: 1;
            		border-radius: 0.24rem;
                }
            }
            
        }
    }
    .telmain{
        position: fixed;
        right: 0.28rem;
        bottom: 3.76rem;
    }
}
</style>